// src/overrides/defaultComponents.tsx
import { jsx } from "react/jsx-runtime";
var DefaultPre = ({ node, ...rest }) => /* @__PURE__ */ jsx("pre", { ...rest });
var DefaultCode = ({ node, ...rest }) => /* @__PURE__ */ jsx("code", { ...rest });
var DefaultCodeBlockContent = ({ node, components: { Pre, Code }, code }) => /* @__PURE__ */ jsx(Pre, { children: /* @__PURE__ */ jsx(Code, { node, children: code }) });
var DefaultCodeHeader = () => null;
export {
  DefaultCode,
  DefaultCodeBlockContent,
  DefaultCodeHeader,
  DefaultPre
};
//# sourceMappingURL=defaultComponents.js.map